var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.05 0 0 4.05 0 9C0 13.95 4.05 18 9 18C13.95 18 18 13.95 18 9C18 4.05 13.95 0 9 0ZM9.9 14.265C9.63 14.49 9.315 14.625 8.955 14.625C8.55 14.625 8.28 14.49 8.055 14.265C7.785 13.995 7.65 13.635 7.65 13.275C7.65 12.825 7.785 12.51 8.055 12.24C8.325 12.015 8.64 11.925 8.955 11.925C9.36 11.925 9.675 12.06 9.945 12.33C10.17 12.555 10.26 12.87 10.305 13.275C10.305 13.68 10.17 13.995 9.9 14.265ZM10.08 6.21C9.855 7.11 9.63 8.64 9.405 10.8H8.55C8.28 8.64 8.055 7.11 7.83 6.21C7.605 5.4 7.47 4.86 7.47 4.635C7.47 4.275 7.605 3.915 7.83 3.645C8.1 3.375 8.46 3.195 9 3.195C9.45 3.195 9.765 3.375 10.035 3.645C10.26 3.915 10.395 4.23 10.395 4.635C10.395 4.86 10.305 5.4 10.08 6.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageError);
export default __webpack_public_path__ + "static/media/message-error.8747607e1e67ab4c3416aca226e6053d.svg";
export { ForwardRef as ReactComponent };